import { ComponentsShowcase } from './ComponentsShowcase';
import { DialogDemo } from './DialogDemo';
import { LoadingViewDemo } from './LoadingViewDemo';
import { PageTitles } from './PageTitles';
import { PresetToColor } from './PresetToColor';
import { ScoreToColor } from './ScoreToColor';
import { SnackbarDemo } from './SnackbarDemo';

export function DevMain() {
  return (
    <div>
      <h3>Quick test with button</h3>
      <button
        onClick={async () => {
          // ...
        }}
      >
        do stuff
      </button>
      <hr />
      <h3>Dialog Demo:</h3>
      <DialogDemo />
      <h3>Snackbar Demo:</h3>
      <SnackbarDemo />
      <h3>Loading view:</h3>
      <LoadingViewDemo />
      <h3>Components showcase</h3>
      <ComponentsShowcase />
      <hr />
      <hr />
      <h3>Score to color:</h3>
      <ScoreToColor />
      <hr />
      <h3>Preset to color:</h3>
      <PresetToColor />
      <hr />
      <h3>Page title:</h3>
      <PageTitles />
    </div>
  );
}
